import CityPageTemplate from "@/pages/hawaii-city/CityPageTemplate";
import { honoluluConfig } from "./data";

export default function HonoluluPage() {
  return <CityPageTemplate config={honoluluConfig} />;
}